import React, { Component } from 'react'
import PropTypes from 'prop-types'
import theme, {whiteLabelData} from '../../theme'
import log from 'loglevel'

import { Link } from 'react-router-dom';
import i18next, {t} from 'i18next';
import { Trans } from 'react-i18next';

// Application Components
import toast from "../../../utils/ToasterService";

// Material components
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography'
import Select from '@mui/material/Select';

const styles = {
    root: {
        padding: theme.spacing(4),
        maxWidth: 420,
        boxSizing: 'border-box',
        width: '100%',
    },
    buttonContainer: {
        marginTop: 20,
    },
    textField: {
      minWidth: 'inherit',
    },
    textFieldFormLabel: {
        '&$textFieldFocused': {
            color: theme.palette.primary.dark,
        },
    },
    textFieldFocused: {},
    textFieldUnerline: {
        '&:after': {
            borderBottomColor: theme.palette.primary.dark,
        },
    },
    selectLang: {
      fontSize: 12,
    }
}

class PasswordNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputs: {
                newPw: '',
                repeatNewPw: ''
            },
            pwError: false,
            success: false,
            language: i18next.language
        }
    }

    static propTypes = {
        classes: PropTypes.objectOf(PropTypes.string).isRequired,
        onSetNewPassword: PropTypes.func,
    };

    handleChangeInput = (key, value) => {
        const { inputs } = this.state;
        inputs[key] = value;
        this.setState({inputs, errorMsg: ''});
    };

    handleSubmit = () => {
        const { inputs: {newPw}} = this.state;

        if (this.inputsValid()) {
            this.props.onSetNewPassword(newPw,
                () => {
                    toast.success(t('PasswordNew.toast_success') );
                    this.setState({success: true})
                },
                (error) => {
                    toast.error(error.msg);
                    log.error('Couldnt set password: ', error)
                })
        } else {
          toast.error(t('PasswordNew.toast_error'));
        }
    };

    checkEnterSubmit = (ev) => {
        if (ev.key === 'Enter') {
            ev.preventDefault();
            this.handleSubmit();
        }
    };

    inputsValid = () => {
        const { inputs: {newPw, repeatNewPw} } = this.state;
        let result = true;
        if (newPw.trim().length > 11 && repeatNewPw.trim().length > 11 && newPw === repeatNewPw) {
          this.setState({pwError: false})
        } else {
          this.setState({pwError: true})
          result = false;
        }
        return result;
    };

    backToLogin = () => {
        this.props.router.push('/login')
    };

    handleLanguageChange = (event) => {
      i18next.changeLanguage(event.target.value)
      this.setState({language: event.target.value})
    }

    render () {
        const { classes } = this.props;
        const { inputs: {newPw, repeatNewPw}, success, pwError } = this.state;

        const passwordError = (newPw.trim().length > 0 && repeatNewPw.trim().length > 0) && (newPw !== repeatNewPw || newPw.length < 12 );
        const repeatPasswordError = ((newPw !== repeatNewPw) && repeatNewPw.length > 0);
        const passwordHelperText = passwordError ? t('PasswordNew.error_text_repeat_password') : '';
        const repeatPWHelperText = repeatPasswordError ? t('PasswordNew.error_text_repeat_password') : '';

        return (
            <Grid
                container
                direction="column"
                justifyContent="center"  // Vertikale Zentrierung
                alignItems="center"        // Horizontale Zentrierung
                style={{ minHeight: '100vh', padding: theme.spacing(2) }} // Füllt die Bildschirmhöhe
            >
                <Grid container justifyContent="center">
                    <Grid item style={{ marginBottom: 20 }}>
                        <img style={{ width: '100%', maxWidth: '300px' }} src={whiteLabelData.logo} alt="" />
                    </Grid>
                </Grid>

                <Paper style={styles.root}>
                    <Grid container direction="column" justify="center" alignItems="center">
                        <Typography style={{ fontSize: 20 }}>
                          {whiteLabelData.name}
                        </Typography>
                        <Typography style={{ fontSize: 16 }}>
                            <Trans i18nKey='PasswordNew.button_reset_password'></Trans>
                        </Typography>
                        {!success && (
                            <div style={{width: "100%"}}>
                                <Grid container justify="center" alignItems="center">
                                    <TextField
                                        InputProps={{
                                            classes: {
                                                underline: styles.textFieldUnerline
                                            },
                                        }}
                                        InputLabelProps={{
                                            FormLabelClasses: {
                                                root: styles.textFieldFormLabel,
                                                focused: styles.textFieldFocused,
                                            },
                                        }}
                                        label={t('PasswordNew.text_field_assign_new_password')}
                                        name={'newPw'}
                                        type="password"
                                        value={newPw}
                                        margin="normal"
                                        style={styles.textField}
                                        required
                                        fullWidth={true}
                                        error={pwError}
                                        helperText={newPw.length < 12 ? t('Registration.textfield_helpertext_password') : passwordHelperText}
                                        onChange={e => this.handleChangeInput(e.target.name, e.target.value)}
                                        onKeyPress={(ev) => this.checkEnterSubmit(ev)}
                                    />
                                    <TextField
                                        InputProps={{
                                            classes: {
                                                underline: styles.textFieldUnerline
                                            },
                                        }}
                                        InputLabelProps={{
                                            FormLabelClasses: {
                                                root: styles.textFieldFormLabel,
                                                focused: styles.textFieldFocused,
                                            },
                                        }}
                                        label={t('PasswordNew.text_field_confirm_new_password')}
                                        name={'repeatNewPw'}
                                        type="password"
                                        value={repeatNewPw}
                                        margin="normal"
                                        style={styles.textField}
                                        required
                                        fullWidth={true}
                                        error={pwError}
                                        helperText={repeatPWHelperText}
                                        onChange={e => this.handleChangeInput(e.target.name, e.target.value)}
                                        onKeyPress={(ev) => this.checkEnterSubmit(ev)}
                                    />
                                </Grid>
                                <Grid container justify="space-between" style={styles.buttonContainer}>
                                  <Grid item>
                                      <Link to="/" style={{ textDecoration: 'none' }}>
                                          <Button style={{color: theme.palette.primary.dark}}><Trans i18nKey='Global.button_cancel'></Trans></Button>
                                      </Link>
                                  </Grid>
                                  <Grid item>
                                    <Button
                                          variant="outlined"
                                          style={{...styles.registerButton, color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark}}
                                          // disabled={ !this.inputsValid() }
                                          onClick={ () => this.handleSubmit() }
                                      ><Trans i18nKey='PasswordNew.button_submit_new_password'></Trans>
                                    </Button>
                                  </Grid>
                                </Grid>
                            </div>)
                        }
                        {success && (
                            <div>
                                <Grid container justify="center" direction="column" alignItems="center">
                                    <Typography style={{...styles.successText, marginTop: 40, marginBottom: 40, fontSize: 14}}>
                                        <Trans i18nKey='PasswordNew.success_text'></Trans>
                                    </Typography>
                                    <Grid item>
                                        <Button
                                            style={{color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20 }}
                                            variant="outlined"
                                            onClick={this.backToLogin}
                                            color="primary">
                                            <Trans i18nKey='PasswordNew.button_back_to_signin'></Trans>
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                    </Grid>
                </Paper>
                <Grid container justifyContent="center">
                  <Grid item style={{ marginTop: 20 }}>
                    <Select
                      native
                      disableUnderline
                      labelId={t('ChooseLanguage.button_choose_language')}
                      id="login_language_selectt"
                      value={this.state.language}
                      onChange={this.handleLanguageChange}
                      style={styles.selectLang}
                    >
                      <option value='en'>English</option>
                      <option value='de'>Deutsch</option>
                    </Select>
                  </Grid>
                </Grid>
            </Grid>
        )
    }
}

export default PasswordNew
